import { createEvent } from 'effector';

export const setNewTicketsCount = createEvent<number>();
